/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Funnel_Footnote_First_TouchInputs */

const en_admin_funnel_footnote_first_touch = /** @type {(inputs: Admin_Funnel_Footnote_First_TouchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source / country = external referrer or utm_source and cf-ipcountry at the visitor's first event, pinned by cookie. Visitors who came before tracking shipped are attributed to their first visit after it.`)
};

/**
* | output |
* | --- |
* | "Source / country = external referrer or utm_source and cf-ipcountry at the visitor's first event, pinned by cookie. Visitors who came before tracking shipped..." |
*
* @param {Admin_Funnel_Footnote_First_TouchInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_funnel_footnote_first_touch = /** @type {((inputs?: Admin_Funnel_Footnote_First_TouchInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Funnel_Footnote_First_TouchInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_funnel_footnote_first_touch(inputs)
});
export { admin_funnel_footnote_first_touch as "admin.funnel.footnote.first_touch" }